var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "申请开具发票", width: "800" },
      on: { "on-cancel": _vm.handleCancel },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.loading
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "Col",
            { attrs: { span: "24" } },
            [
              _c(
                "Form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.dynamicRules,
                    "label-position": "right",
                    "label-width": 150,
                  },
                },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24", "class-name": "invoiceField" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "开具类型:",
                                prop: "invoiceBuyerType",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: {
                                    placeholder: "请选择开具类型",
                                    disabled: "",
                                  },
                                  on: {
                                    "on-change": _vm.onInvoiceBuyerTypeChange,
                                  },
                                  model: {
                                    value: _vm.form.invoiceBuyerType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "invoiceBuyerType",
                                        $$v
                                      )
                                    },
                                    expression: "form.invoiceBuyerType",
                                  },
                                },
                                [
                                  _c("Option", { attrs: { value: "企业" } }, [
                                    _vm._v("企业"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "24", "class-name": "invoiceField" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "发票类型:",
                                prop: "invoiceLine1",
                              },
                            },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  on: { "on-change": _vm.onInvoiceLine1Change },
                                  model: {
                                    value: _vm.form.invoiceLine1,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceLine1", $$v)
                                    },
                                    expression: "form.invoiceLine1",
                                  },
                                },
                                [
                                  _c("Radio", { attrs: { label: "数电普票" } }),
                                  _vm.form.invoiceBuyerType === "企业"
                                    ? _c("Radio", {
                                        attrs: { label: "数电专票" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "24", "class-name": "invoiceField" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "介质类型:",
                                prop: "invoiceLine2",
                              },
                            },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  model: {
                                    value: _vm.form.invoiceLine2,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceLine2", $$v)
                                    },
                                    expression: "form.invoiceLine2",
                                  },
                                },
                                [_c("Radio", { attrs: { label: "电子发票" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "24", "class-name": "invoiceField" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "发票抬头:",
                                prop: "invoiceBuyerName",
                              },
                            },
                            [
                              _c("Input", {
                                attrs: { placeholder: "请输入发票抬头" },
                                model: {
                                  value: _vm.form.invoiceBuyerName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "invoiceBuyerName", $$v)
                                  },
                                  expression: "form.invoiceBuyerName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _vm.form.invoiceBuyerType === "企业"
                        ? _c(
                            "Col",
                            {
                              attrs: {
                                span: "24",
                                "class-name": "invoiceField",
                              },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "统一社会信用代码:",
                                    prop: "invoiceBuyerTaxNum",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入统一社会信用代码",
                                    },
                                    model: {
                                      value: _vm.form.invoiceBuyerTaxNum,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "invoiceBuyerTaxNum",
                                          $$v
                                        )
                                      },
                                      expression: "form.invoiceBuyerTaxNum",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      ["数电专票"].includes(_vm.form.invoiceLine1)
                        ? _c(
                            "Col",
                            {
                              attrs: {
                                span: "24",
                                "class-name": "invoiceField",
                              },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "开户银行名称:",
                                    prop: "invoiceBuyerBank",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入开户银行名称（选填）",
                                    },
                                    model: {
                                      value: _vm.form.invoiceBuyerBank,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "invoiceBuyerBank",
                                          $$v
                                        )
                                      },
                                      expression: "form.invoiceBuyerBank",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      ["数电专票"].includes(_vm.form.invoiceLine1)
                        ? _c(
                            "Col",
                            {
                              attrs: {
                                span: "24",
                                "class-name": "invoiceField",
                              },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "基本开户账号:",
                                    prop: "invoiceBuyerAccount",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入基本开户账号（选填）",
                                    },
                                    model: {
                                      value: _vm.form.invoiceBuyerAccount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "invoiceBuyerAccount",
                                          $$v
                                        )
                                      },
                                      expression: "form.invoiceBuyerAccount",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      ["数电专票"].includes(_vm.form.invoiceLine1)
                        ? _c(
                            "Col",
                            {
                              attrs: {
                                span: "24",
                                "class-name": "invoiceField",
                              },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "注册场所地址:",
                                    prop: "invoiceBuyerAddress",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入注册场所地址（选填）",
                                    },
                                    model: {
                                      value: _vm.form.invoiceBuyerAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "invoiceBuyerAddress",
                                          $$v
                                        )
                                      },
                                      expression: "form.invoiceBuyerAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      ["数电专票"].includes(_vm.form.invoiceLine1)
                        ? _c(
                            "Col",
                            {
                              attrs: {
                                span: "24",
                                "class-name": "invoiceField",
                              },
                            },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "注册固定电话:",
                                    prop: "invoiceBuyerTel",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      placeholder: "请输入注册固定电话（选填）",
                                    },
                                    model: {
                                      value: _vm.form.invoiceBuyerTel,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "invoiceBuyerTel",
                                          $$v
                                        )
                                      },
                                      expression: "form.invoiceBuyerTel",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("div", [
            _c("span", [
              _vm._v("待开票金额：" + _vm._s(_vm.form.invoiceValue)),
            ]),
            _c("span", [
              _vm._v(
                "（货款：" +
                  _vm._s(_vm.form.invoiceProductValue) +
                  ",运费：" +
                  _vm._s(_vm.form.invoiceDeliveryFee) +
                  ",包装费：" +
                  _vm._s(_vm.form.invoicePackageFee) +
                  ")"
              ),
            ]),
          ]),
          _c(
            "div",
            [
              _c(
                "Button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.onApplyInvoice },
                },
                [_vm._v("\n                保存\n            ")]
              ),
              _vm.form.isCanSubmit
                ? _c(
                    "Button",
                    {
                      attrs: { type: "info", loading: _vm.loading },
                      on: { click: _vm.preViewInvoice },
                    },
                    [_vm._v("\n                预览\n            ")]
                  )
                : _vm._e(),
              _c("Button", { on: { click: _vm.handleCancel } }, [
                _vm._v("\n                取消\n            "),
              ]),
            ],
            1
          ),
        ]
      ),
      _c("invoicePreviewModal", {
        ref: "invoicePreviewModal",
        on: {
          "invoice-submitted": _vm.onInvoiceSubmittedFromPreview,
          "invoice-submit-error": _vm.onInvoiceSubmitErrorFromPreview,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }